import { Route, Routes } from "react-router-dom";
import { styled } from "styled-components";
import AboutUs from "./pages/About/AboutUs";
import Home from "./pages/Home/Home";
import Oops from "./pages/Oops/Oops";

import "./App.css";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

import { useEffect } from "react";
import { Provider } from "react-redux";
import { scrollEvent } from "./app/scrollBarSlice";
import store from "./app/store";
import { screenResize } from "./app/windowSlice";

/* Outer banner working */
const GodBanner = styled.div`
  position: relative;
  top: -100px;
  display: flex;
  height: calc(100% - 300px);
  width: 100%;
  background-color: #fff1d0;
  background-repeat: no-repeat;
  background-size: cover;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

function App() {
  useEffect(() => {
    window.addEventListener("resize", () => {
      store.dispatch(
        screenResize({
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight,
        })
      );
    });

    window.addEventListener("scroll", (event) => {
      store.dispatch(scrollEvent({ scrollHeight: window.scrollY }));
    });

    return () => {
      window.removeEventListener("scroll", Function.prototype);
      window.removeEventListener("resize", Function.prototype);
    };
  }, []);

  return (
    <Provider store={store}>
      <div className="App">
        <Navbar />
        <GodBanner className="App-header">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="*" element={<Oops />} />
          </Routes>
        </GodBanner>
        <Footer />
      </div>
    </Provider>
  );
}

export default App;
